export enum LoadingStateEnum {
  LOADING = 'loading',
  DONE = 'DONE',
  IDLE = 'idle',
}

export enum LogoVariantEnum {
  FULL = 'full',
  ICON = 'icon',
  TEXT = 'text',
}

export enum ThemeEnum {
  DARK = 'dark',
  MIDNIGHT_BLUE = 'midnight_blue',
  LIGHT = 'light',
}
